import { StatusPillVariant } from '../../../../shared/ui/status-pill/status-pill.component';
import { InvestmentInCompaniesModel } from '../../../../modules/investment/incompanies/investment-incompanies.model';
import {
  investmentPaymentLabel as investmentPaymentLabelFor,
  investmentPaymentVariant as investmentPaymentVariantFor,
} from '../../shared/investment-payment-status.util';
import { roundAmount } from '../../../../shared/round-amount';

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const INVESTMENT_COMPANY_PAY_METHODS = {
  cash: 'Efectivo',
  card: 'Tarjeta de crédito',
  transfer: 'Transferencia bancaria',
  partner: 'Socio',
  creditPolicy: 'Póliza de crédito',
};

export const INVESTMENT_COMPANY_PAY_METHOD_OPTIONS: string[] = [
  INVESTMENT_COMPANY_PAY_METHODS.cash,
  INVESTMENT_COMPANY_PAY_METHODS.card,
  INVESTMENT_COMPANY_PAY_METHODS.transfer,
  INVESTMENT_COMPANY_PAY_METHODS.partner,
  INVESTMENT_COMPANY_PAY_METHODS.creditPolicy,
];

export interface InvestmentCompanyRow extends InvestmentInCompaniesModel {
  paidAmount: number;
  pendingAmount: number;
  percent: number;
  __expanded?: boolean;
  __selected?: boolean;
}

export interface InvestmentCompanyListSummary {
  count: number;
  investmentValue: number;
  netBookValue: number;
  paidAmount: number;
  pendingAmount: number;
}

export function roundMoney(value: number): number {
  return roundAmount(value);
}

export function hasInvestmentFile(item: InvestmentInCompaniesModel): boolean {
  return !!item && (item.isImage === true || item.isPdf === true);
}

export function toInvestmentCompanyRow(item: InvestmentInCompaniesModel, expanded: boolean, selected = false): InvestmentCompanyRow {
  const value = roundMoney(item.investmentValue);
  const paid = roundMoney(item.paidAmount != null ? item.paidAmount : paidFromLegacy(item));
  const pending = roundMoney(Math.max(0, value - paid));
  const percent = value > 0 ? Math.min(100, Math.max(0, (paid / value) * 100)) : 0;
  return {
    ...item,
    paidAmount: paid,
    pendingAmount: pending,
    percent,
    __expanded: expanded,
    __selected: selected,
  };
}

export function investmentPaymentLabel(row: InvestmentCompanyRow): string {
  return investmentPaymentLabelFor(row ? { total: row.investmentValue, paid: row.paidAmount, pending: row.pendingAmount, paidDate: row.lastDepositDate } : null);
}

export function investmentPaymentVariant(row: InvestmentCompanyRow): StatusPillVariant {
  return investmentPaymentVariantFor(row ? { total: row.investmentValue, paid: row.paidAmount, pending: row.pendingAmount } : null);
}

function paidFromLegacy(item: InvestmentInCompaniesModel): number {
  const raw = item && item.paided != null ? String(item.paided).trim() : '';
  if (!raw) return 0;
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) return Number(item.investmentValue) || 0;
  const value = Number(raw.replace(/\s/g, '').replace(',', '.'));
  return isFinite(value) ? value : 0;
}
